import React, { CSSProperties } from "react";
import { Box, Typography, Theme, SxProps } from "@mui/material";
import { SystemStyleObject } from "@mui/system";
import { BlockDateModel } from "Backend";
import SimpleMenu, { SimpleMenuItem } from "components/SimpleMenu";
import ErrorIcon from "@mui/icons-material/ErrorOutline";
import theme from "theme";

interface BannerStyles {
  root: SxProps<Theme>;
  bannerIcon: SxProps<Theme>;
  bannerTitle: SxProps<Theme>;
  actionMenu: SystemStyleObject;
  titleText: SxProps<Theme>;
}

const bannerStyles: BannerStyles = {
  root: {
    padding: theme.spacing(0.5),
    display: "flex",
    flexGrow: 0,
    justifyContent: "space-between",
    width: "100%",
  },
  bannerIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(2),
  },
  bannerTitle: {
    display: "flex",
    alignItems: "center",
  },
  actionMenu: {
    marginLeft: theme.spacing(1),
  },
  titleText: {
    fontWeight: "bold",
  },
};

export interface CardBannerProps {
  icon: React.ReactNode;
  titleText: string;
  date?: BlockDateModel | null;
  actionItems?: SimpleMenuItem[];
  addEventButton?: React.ReactNode;
  dismissButton?: React.ReactNode;
}

export const CardBanner = (props: CardBannerProps) => {
  const { addEventButton, dismissButton, actionItems } = props;
  return (
    <Box sx={bannerStyles.root}>
      <Box sx={bannerStyles.bannerTitle}>
        <Box sx={bannerStyles.bannerIcon}>{props.icon}</Box>
        <Typography sx={bannerStyles.titleText}>{props.titleText}</Typography>
      </Box>
      <Box display="flex" flexDirection="row" alignItems="center">
        <Typography>
          <b>{props.date?.display()}</b>
        </Typography>
        {addEventButton}
        {dismissButton}
        {actionItems && <SimpleMenu sx={bannerStyles.actionMenu} items={actionItems} meatball />}
      </Box>
    </Box>
  );
};

export interface BadReadBannerProps {
  date?: BlockDateModel | null;
  actionItems?: SimpleMenuItem[];
  style?: CSSProperties;
  className?: string;
}

export const BadReadBanner = (props: BadReadBannerProps) => {
  const { date } = props;
  return (
    <Box sx={bannerStyles.root} style={props.style}>
      <Box sx={bannerStyles.bannerTitle}>
        <ErrorIcon sx={bannerStyles.bannerIcon} />
        <Typography sx={bannerStyles.titleText}>Unreadable Text</Typography>
      </Box>
      <Box display="flex" flexDirection="row" alignItems="center">
        <Typography>{date?.display()}</Typography>
        {props.actionItems && <SimpleMenu sx={bannerStyles.actionMenu} items={props.actionItems} hamburger />}
      </Box>
    </Box>
  );
};
